
import React from 'react';
import { zones } from './LeaderboardTypes';
import { 
  Brain, 
  Droplets,
  Leaf, 
  Moon, 
  Award, 
  Users, 
  Pill 
} from 'lucide-react';

interface ZoneFilterProps {
  selectedZone: string | null;
  setSelectedZone: (zone: string | null) => void;
}

const ZoneFilter: React.FC<ZoneFilterProps> = ({ selectedZone, setSelectedZone }) => {
  // Icon mapping
  const iconComponents = {
    Brain,
    Droplets,
    Leaf,
    Moon,
    Award,
    Users,
    Pill
  };

  return (
    <div className="mb-6">
      <h2 className="text-xl font-semibold mb-3">Zones</h2>
      <p className="text-sm text-muted-foreground mb-4">
        Filter the leaderboard by different zones to see where you excel. Engage with multiple zones to boost your overall ranking!
      </p>
      <div className="flex flex-wrap gap-2">
        <button 
          className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
            selectedZone === null ? 'bg-hormony-coral text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
          onClick={() => setSelectedZone(null)}
        >
          Overall
        </button>
        
        {zones.map(zone => {
          const IconComponent = iconComponents[zone.icon as keyof typeof iconComponents];
          return (
            <button
              key={zone.id}
              className={`px-3 py-1.5 rounded-full text-sm font-medium flex items-center gap-1 transition-colors ${
                selectedZone === zone.id ? `${zone.color} bg-opacity-100` : `${zone.color} bg-opacity-50 hover:bg-opacity-70`
              }`}
              onClick={() => setSelectedZone(zone.id)}
            >
              <IconComponent size={14} />
              {zone.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ZoneFilter;
